import { render, staticRenderFns } from "./DashboardWeeklyModal.vue?vue&type=template&id=d18da7fa&scoped=true"
import script from "./DashboardWeeklyModal.vue?vue&type=script&lang=js"
export * from "./DashboardWeeklyModal.vue?vue&type=script&lang=js"
import style0 from "./DashboardWeeklyModal.vue?vue&type=style&index=0&id=d18da7fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18da7fa",
  null
  
)

export default component.exports